export const REQUIRED_FIELD = 'Это обязательное поле';
export const EMAIL_ERROR_FORMAT = 'Неправильный формат электронной почты';

export const EMAIL_PATTERN = '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{1,}$';
export const EMAIL_EXAMPLE = 'simple@example.com';
